import { LoaderFunctionArgs, redirect } from "react-router";

export default async function bookmarksLoader(args: LoaderFunctionArgs) {
  const tab = args.params.tab;
  if (!tab) return redirect("/marketplace/bookmarks/individual");
  return tab;
}
